var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar'),_c('debate-hero'),_c('debate'),_c('debate-tabs'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }